"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLocalStorageStateHook = void 0;

var react_1 = require("react");
/**
 * A wrapper for `JSON.parse()` which supports the return value of `JSON.stringify(undefined)`
 * which returns the string `"undefined"` and this method returns the value `undefined`.
 */


function parseJSON(value) {
  return value === 'undefined' ? undefined : // JSON.parse() doesn't accept non-string values, this is why we pass empty
  // string which will throw an error which can be handled
  JSON.parse(value !== null && value !== void 0 ? value : '');
}
/**
 * Abstraction for localStorage that uses an in-memory fallback when localStorage throws an error.
 * Reasons for throwing an error:
 * - maximum quota is exceeded
 * - under Mobile Safari (since iOS 5) when the user enters private mode `localStorage.setItem()`
 *   will throw
 * - trying to access localStorage object when cookies are disabled in Safari throws
 *   "SecurityError: The operation is insecure."
 */


var data = {};
var storage = {
  get: function get(key, defaultValue) {
    var _a;

    try {
      return (_a = data[key]) !== null && _a !== void 0 ? _a : parseJSON(localStorage.getItem(key));
    } catch (_b) {
      return defaultValue;
    }
  },
  set: function set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      data[key] = undefined;
      return true;
    } catch (_a) {
      data[key] = value;
      return false;
    }
  },
  remove: function remove(key) {
    data[key] = undefined;

    try {
      localStorage.removeItem(key);
    } catch (_a) {}
  }
};
/**
 * Used to track usages of `useLocalStorageState()` with identical `key` values. If we encounter
 * duplicates we throw an error to the user telling them to use `createLocalStorageStateHook`
 * instead.
 */

var initializedStorageKeys = new Set();

function useLocalStorageState(key, defaultValue) {
  // we don't support updating the `defaultValue` the same way `useState()` doesn't support it
  var _react_1$useState = react_1.useState(function () {
    var isCallable = function isCallable(value) {
      return typeof value === 'function';
    };

    return isCallable(defaultValue) ? defaultValue() : defaultValue;
  }),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 1),
      defaultValueState = _react_1$useState2[0];

  var getDefaultState = react_1.useCallback(function () {
    return {
      value: storage.get(key, defaultValueState),
      isPersistent: function () {
        /**
         * We want to return `true` on the server. If you render a message based on `isPersistent` and the
         * server returns `false` then the message will flicker until hydration is done:
         * `{!isPersistent && <span>You changes aren't being persisted.</span>}`
         */
        if (typeof window === 'undefined') {
          return true;
        }

        try {
          localStorage.setItem('--use-local-storage-state--', 'dummy');
          localStorage.removeItem('--use-local-storage-state--');
          return true;
        } catch (_a) {
          return false;
        }
      }()
    };
  }, [defaultValueState, key]);

  var _react_1$useState3 = react_1.useState(getDefaultState),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      state = _react_1$useState4[0],
      setState = _react_1$useState4[1];

  var updateValue = react_1.useMemo(function () {
    var fn = function fn(newValue) {
      var isCallable = function isCallable(value) {
        return typeof value === 'function';
      };

      if (isCallable(newValue)) {
        setState(function (state) {
          return {
            value: newValue(state.value),
            isPersistent: storage.set(key, newValue(state.value))
          };
        });
      } else {
        setState({
          value: newValue,
          isPersistent: storage.set(key, newValue)
        });
      }
    };

    fn.reset = function () {
      storage.remove(key);
      setState(function (state) {
        return {
          value: defaultValueState,
          isPersistent: state.isPersistent
        };
      });
    };

    return fn;
  }, [key, defaultValueState]);
  /**
   * Detects incorrect usage of the library and throws an error with a suggestion how to fix it.
   */

  react_1.useEffect(function () {
    if (initializedStorageKeys.has(key)) {
      throw new Error("Multiple instances of useLocalStorageState() has been initialized with the same key. " + "Use createLocalStorageStateHook() instead. " + "Example implementation: " + "https://github.com/astoilkov/use-local-storage-state#create-local-storage-state-hook-example");
    } else {
      initializedStorageKeys.add(key);
    }

    return function () {
      return void initializedStorageKeys.delete(key);
    };
  }, [key]);
  /**
   * Syncs changes across tabs and iframe's.
   */

  react_1.useEffect(function () {
    var onStorage = function onStorage(e) {
      if (e.storageArea === localStorage && e.key === key) {
        setState({
          value: storage.get(key, defaultValueState),
          isPersistent: true
        });
      }
    };

    window.addEventListener('storage', onStorage);
    return function () {
      return window.removeEventListener('storage', onStorage);
    };
  }, [key, defaultValueState]);
  /**
   * Update the state when the `key` property changes.
   */

  var isFirstRender = react_1.useRef(true);
  react_1.useEffect(function () {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setState(getDefaultState());
  }, [getDefaultState]);
  return [state.value, updateValue, state.isPersistent];
}

exports.default = useLocalStorageState;

function createLocalStorageStateHook(key, defaultValue) {
  var updates = [];
  return function useLocalStorageStateHook() {
    var _useLocalStorageState = useLocalStorageState(key, defaultValue),
        _useLocalStorageState2 = _slicedToArray(_useLocalStorageState, 3),
        value = _useLocalStorageState2[0],
        setValue = _useLocalStorageState2[1],
        isPersistent = _useLocalStorageState2[2];

    var updateValue = react_1.useMemo(function () {
      var fn = function fn(newValue) {
        var _iterator = _createForOfIteratorHelper(updates),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var update = _step.value;
            update(newValue);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };

      fn.reset = function () {
        var _iterator2 = _createForOfIteratorHelper(updates),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var update = _step2.value;
            update.reset();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };

      return fn;
    }, []);
    react_1.useEffect(function () {
      initializedStorageKeys.delete(key);
    }, []);
    react_1.useEffect(function () {
      updates.push(setValue);
      return function () {
        return void updates.splice(updates.indexOf(setValue), 1);
      };
    }, [setValue]);
    return [value, updateValue, isPersistent];
  };
}

exports.createLocalStorageStateHook = createLocalStorageStateHook;